import { dateObjToLocalZone } from '../../../utils/converter';
// import { hashExistInFiles } from '../../../utils/fileHelpers';
import { ValidationInformationResult } from './ValidationInformationResult';

export const ValidationInformation = ({ reportData, files, handleNotValidated }) => {
  // console.log('reportData', reportData);
  return (
    <div className="flex flex-col rounded-lg bg-[#17191C] p-4 sm:p-6 gap-4 sm:gap-6">
      <h3 className="font-normal text-xl md:text-2xl">Analyzation Information</h3>
      <table className="w-full table-fixed file-table">
        <tbody className="w-full flex flex-col gap-1">
          <tr className="flex flex-col bg-core-black-contrast-2 px-3 sm:px-4 py-3 sm:py-4 md:py-[12px] w-full gap-1 rounded-sm">
            <th className="text-white text-sm sm:text-base">Date:</th>
            <th className="font-normal text-core-grey-80 text-sm sm:text-base">
              <p>{dateObjToLocalZone(reportData.VALIDATION_DATE)}</p>
            </th>
          </tr>
          <tr className="flex flex-col bg-core-black-contrast-2 px-3 sm:px-4 py-3 sm:py-4 md:py-[12px] w-full gap-1 rounded-sm">
            <th className="text-white text-sm sm:text-base">Result:</th>
            <td className="font-normal text-core-grey-80 text-sm sm:text-base">
              <ValidationInformationResult reportData={reportData} />
            </td>
          </tr>
          <tr className="flex flex-col bg-core-black-contrast-2 px-3 sm:px-4 py-3 sm:py-4 md:py-[12px] w-full gap-1 rounded-sm">
            <th className="text-white text-sm sm:text-base">Verification method:</th>
            <td className="font-normal text-core-grey-80 text-sm sm:text-base">
              <p>Stamped</p>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

// OLD
// export const ValidationInformation = ({ reportData, files, handleNotValidated }) => {
//   const formatMethod = (method) => {
//     switch (method) {
//       case 'timestamp':
//         return 'Time stamp';
//       case 'fullfile':
//         return 'Full file';
//       case 'standard':
//         return 'Standard value';
//       case 'random':
//         return 'Any value';
//       case 'all tested':
//         return 'All tested';
//       default:
//         return 'Unknown';
//     }
//   };
//   return (
//     <div className="flex flex-col rounded-[20px] bg-[#17191C] p-[24px] gap-[24px]">
//       <h3 className="text-[28px] space-y-[33.6px]">Validation Information</h3>
//       <table className="w-full table-fixed file-table">
//         <tbody className="w-full flex flex-col gap-[2px]">
//           <tr className="flex flex-col bg-[#282B2E] px-[16px] py-[12px] w-full gap-[16px] rounded-[4px]">
//             <th className="font-bold text-white">Date:</th>
//             <th className="">
//               {+reportData.VALID === 0 || +reportData.VALID === 1 ? (
//                 <p>{dateObjToLocalZone(reportData.VALIDATION_DATE)}</p>
//               ) : (
//                 <p>
//                   {+reportData.VALID === 2 && hashExistInFiles(files, reportData.HASH) ? (
//                     <span>Pending</span>
//                   ) : (
//                     <>
//                       <span></span>
//                       <a
//                         onClick={() => handleNotValidated(reportData.HASH)}
//                         className="text-blue-400 cursor-pointer"
//                       >
//                         Click here to Verify.
//                       </a>
//                     </>
//                   )}
//                 </p>
//               )}
//             </th>
//           </tr>
//           <tr className="flex flex-col bg-[#282B2E] px-[16px] py-[12px] w-full gap-[16px] rounded-[4px]">
//             <th className="font-bold text-white">Result:</th>
//             <td className="">
//               <ValidationInformationResult reportData={reportData} />
//             </td>
//           </tr>
//           <tr className="flex flex-col bg-[#282B2E] px-[16px] py-[12px] w-full gap-[16px] rounded-[4px]">
//             <th className="font-bold text-white">Verification method:</th>
//             <td className="">
//               <p>{formatMethod(reportData.VALIDATION_METHOD)}</p>
//             </td>
//           </tr>
//         </tbody>
//       </table>
//     </div>
//   );
// };
